import React, { useState } from 'react'
import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'

export default function ModalDeleteOrg({
    open,
    setOpen,
    onSubmit,
    message,
    disabled,
    data,
}) {
    const [inputValue, setInputValue] = useState('')

    const handleInputChange = (e) => {
        setInputValue(e.target.value)
    }

    const isDeleteEnabled = inputValue === data.keyName

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <Box
                sx={{
                    position: 'absolute',
                    width: 420,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    padding: '32px 24px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: 3,
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} align='center'>
                        <CancelOutlinedIcon
                            color='error'
                            sx={{ fontSize: 60 }}
                        />
                    </Grid>

                    <Grid item xs={12} align='center'>
                        <Typography variant='h6' fontWeight='bold'>
                            Are you sure?
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography
                            variant='body1'
                            align='center'
                            color='text.secondary'
                        >
                            To confirm, type the name&nbsp;
                            <span
                                style={{ fontWeight: 'bold', color: '#d32f2f' }}
                            >
                                "{data.keyName}"
                            </span>
                            &nbsp;to delete.
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            size='small'
                            label='Confirm by typing the name'
                            value={inputValue}
                            onChange={handleInputChange}
                            variant='outlined'
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        display='flex'
                        justifyContent='center'
                        gap={2}
                        mt={1}
                    >
                        <Button
                            disabled={disabled || !isDeleteEnabled}
                            color='error'
                            variant='contained'
                            onClick={onSubmit}
                            sx={{ textTransform: 'none', minWidth: 100 }}
                        >
                            Delete
                        </Button>
                        <Button
                            onClick={() => setOpen(false)}
                            sx={{
                                textTransform: 'none',
                                minWidth: 100,
                                backgroundColor: '#e0e0e0',
                                color: '#333',
                                '&:hover': {
                                    backgroundColor: '#d5d5d5',
                                },
                            }}
                            variant='contained'
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    )
}
